import { INTERNAL_ROUTES } from '../static/Urls';
import apiService from '../service/ApiService';
import { legacyGetOnError } from './ApiUtils';
import { FetchSandboxUser } from '@shared/api/dto/BoxUserDetails';

const sandboxUserDetailsApiUrl = INTERNAL_ROUTES.API_PATH + '/api/sandboxuser';

const fetchSandboxUser = (): Promise<FetchSandboxUser> => {
  return apiService.callGet<FetchSandboxUser>(
    sandboxUserDetailsApiUrl,
    { withCredentials: true },
    undefined,
    legacyGetOnError(),
  );
};

const sandboxUserCredApi = {
  fetchSandbox: fetchSandboxUser,
};

export default sandboxUserCredApi;
